import { isInternalUrl } from './isInternalUrl';

export const getLinkTargetByUrl = (url: string) => (isInternalUrl(url) ? '_self' : '_blank');
